var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.562,
    height: 32.562,
    viewBox: "0 0 32.562 32.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle",
    transform: "translate(16.281) rotate(45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7324",
    "data-name": "Rectangle 7324",
    width: 23.025,
    height: 23.025,
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_626",
    "data-name": "Ellipse 626",
    cx: 8.373,
    cy: 8.373,
    r: 8.373,
    transform: "translate(2.791 2.791)",
    fill: "none",
    stroke: "#191bc3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_376",
    "data-name": "Line 376",
    x1: 5.582,
    y2: 5.582,
    transform: "translate(8.373 8.373)",
    fill: "none",
    stroke: "#191bc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_377",
    "data-name": "Line 377",
    x1: 5.582,
    y1: 5.582,
    transform: "translate(8.373 8.373)",
    fill: "none",
    stroke: "#191bc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.e960106f6e9865f8183b464eed45a251.svg";
export { ForwardRef as ReactComponent };